import { Component, h } from 'preact'
import EmptyPage from '../../empty-page/EmptyPage'
import Header from '../../header'
import AuthorCell from '../../articles/cells/AuthorCell'
import LastEditedCell from '../../articles/cells/LastEditedCell'
import PublishDateCell from '../../articles/cells/PublishDateCell'
import StatusCell from '../../articles/cells/StatusCell'
import TitleCell from '../../articles/cells/TitleCell'
import Table from '../../table/Table'
import axios from 'axios'
import Loader from '../../ui-components/Loader'
import { ProductUpdate, Author, OverviewDataResponse } from './Types'
import OverviewFilters from './OverviewFilters'

const model = [{
  header: 'Title', accessor: 'title', cell: TitleCell()
}, {
  header: 'Status', accessor: 'status', cell: StatusCell()
}, {
  header: 'Likes', accessor: 'likes'
}, {
  header: 'Publish date', accessor: 'publish_date', cell: PublishDateCell(), sorting: 'publishedAt'
}, {
  header: 'Author', accessor: 'author', cell: AuthorCell()
}, {
  header: 'Last edited', accessor: 'last_edited_date', cell: LastEditedCell(), sorting: 'lastEditedAt'
}]

const endpoints = {
  list: '/product-update/listProductUpdates'
}

const emptyFilters = {
  label: [],
  author: [],
  search: []
}

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 25
const DEFAULT_ORDER = 'lastEditedAt'
const DEFAULT_DIRECTION = 'desc'

export const DEFAULT_FILTER_CRITERIA = {
  filters: emptyFilters,
  pagination: {
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE
  },
  sort: {
    order: DEFAULT_ORDER,
    direction: DEFAULT_DIRECTION
  }
}
const FILTER_STORAGE_KEY = 'filterCriteriaProductArticles'

export type ImageData = {
  source_thumb: string,
  source: string,
  type: string,
  bbcode_url:string,
  short_url: string,
  short_thumb_url: string
}

type sortOptions = {
  order: string,
  direction: string
}

export type appliedFilters = {
  id: string,
  name: string,
  type: string
}

export type filteringOptions = {
  label: Array<appliedFilters>,
  author: Array<appliedFilters>,
  search: Array<appliedFilters>
}

type paginationMetadata = {
  page: number,
  pageSize: number
}

interface Props {
  defaultCdn: string
}

interface State {
  productUpdates: Array <ProductUpdate>,
  labels: Array<string>,
  authors: Array<Author>,
  pagination: paginationMetadata,
  loading: boolean,
  filters: filteringOptions,
  areFiltersApplied: boolean,
  sort: sortOptions
}

export class productUpdatesOverview extends Component<Props, State> {

  constructor (props: Props) {
    super()
    this.state = {
      productUpdates: [],
      labels: [],
      authors: [],
      pagination: DEFAULT_FILTER_CRITERIA.pagination,
      loading: false,
      filters: DEFAULT_FILTER_CRITERIA.filters,
      areFiltersApplied: false,
      sort: DEFAULT_FILTER_CRITERIA.sort
    }
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onClearFilterCriteria = this.onClearFilterCriteria.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
    this.updateSortCriteria = this.updateSortCriteria.bind(this)
  }

  componentDidMount () {
    if (!window.sessionStorage.getItem(FILTER_STORAGE_KEY)) {
      window.sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(DEFAULT_FILTER_CRITERIA))
      this.fetchArticles()
    } else {
      const searchCriteria = window.sessionStorage.getItem(FILTER_STORAGE_KEY) && JSON.parse(window.sessionStorage.getItem(FILTER_STORAGE_KEY) as string)
      const { filters, pagination: { page, pageSize }, sort } = searchCriteria
      const areFiltersApplied = JSON.stringify(filters) !== JSON.stringify(DEFAULT_FILTER_CRITERIA.filters)
      this.setState({ filters, pagination: { page, pageSize }, sort, areFiltersApplied: areFiltersApplied })
      this.fetchArticles(page, pageSize, filters, sort)
    }
  }

  fetchArticles (page = DEFAULT_PAGE, pageSize = DEFAULT_PAGE_SIZE, filters = {}, sort = {} as sortOptions) {
    this.setState({ loading: true })
    const url = this.getRequestUrl(page, pageSize, filters, sort)
    axios.get(url).then(res => this.handleResponse(res)).catch(() => this.setState({ loading: false }))
  }

  handleResponse (response: OverviewDataResponse) {
    const { publicLabels, authors, productUpdates, pagination } = response.data
    this.setState({
      labels: publicLabels || [],
      authors: authors || [],
      productUpdates: productUpdates || [],
      pagination: pagination,
      loading: false
    })
  }

  onSortChange (order: string) {
    const { direction } = this.state.sort

    if (direction === 'desc') this.updateSortCriteria(order, 'asc')
    if (direction === 'asc') this.updateSortCriteria(order, 'desc')
  }

  updateSortCriteria (order: string, newDirection: string) {
    this.setState({ sort: { order: order, direction: newDirection } }, () => {
      const { filters, pagination: { page, pageSize }, sort } = this.state
      this.fetchArticles(page, pageSize, filters, sort)
      this.updateFilterCriteria('sort', sort)
    })
  }


  onFilterChange (filter: string, options: Array<appliedFilters>) {
    this.setState({
      filters: { ...this.state.filters, [filter]: options },
      areFiltersApplied: true
    }, () => {
      const { filters, pagination: { page, pageSize } } = this.state
      this.fetchArticles(page, pageSize, filters)
      this.updateFilterCriteria('filters', filters)
    })
  }

  updateFilterCriteria (key: string, value: filteringOptions | sortOptions) {
    let storage = JSON.parse(window.sessionStorage.getItem(FILTER_STORAGE_KEY) as string)
    storage[key] = value
    window.sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(storage))
  }

  onClearFilterCriteria () {
    window.sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(DEFAULT_FILTER_CRITERIA))
    this.setState({ filters: emptyFilters, areFiltersApplied: false })
    this.fetchArticles()
  }

  getRequestUrl (page: number, pageSize: number, filters: any, sort: sortOptions) {
    let url = `${endpoints.list}?page=${page}&pageSize=${pageSize}`

    Object.keys(filters).forEach((filterKey) => {
      filters[filterKey].forEach((filterValue: any) => {
        if (filterKey === 'search') {
          url = url.concat(`&q=${filterValue.id}`)
        } else {
          url = url.concat(`&${filterKey}[]=${filterValue.id}`)
        }
      })
    })

    if (sort.order && sort.direction) {
        url = url.concat(`&order=${sort.order}&direction=${sort.direction}`)
    } 

    return url
  }

  render ({ defaultCdn = '' }: Props, { productUpdates, sort, loading, labels, authors, filters, areFiltersApplied }: State) {
    return (
      <div className='group-overview-page'>
        <Header
          title='Product updates'
          disableCancelButton
          disableSaveButton
        />
        {(productUpdates.length > 0 || areFiltersApplied) && <OverviewFilters
          labels={labels}
          authors={authors}
          filters={filters}
          onFilterChange={this.onFilterChange}
          onClearFilterCriteria={this.onClearFilterCriteria}
        />}
        {loading && <Loader />}
        {
          !productUpdates.length ? (
            !loading && areFiltersApplied ? <EmptyPage
              img_src={`${defaultCdn}/images/empty_result.png`}
              header='No results found'
              text={'Sorry, that filter combination has no results.\n Please try different criteria.'}
            />
            : !loading && <EmptyPage
              img_src={`${defaultCdn}/images/empty_page.png`}
              header='No product update found'
              text={'Seems like no one on your team has created any product update. Start now by creating a new product update.'}
              button={{ link: '/content/new/product_update', text: 'New product update' }}
            />
          ) : (
            <div>
              <Table model={model} rows={productUpdates} rowId={'product_update_id'} sort={sort} onSortChange={this.onSortChange}/>
            </div>
          )
        }
      </div>
    )
  }
}

export default productUpdatesOverview
